import React from 'react'
import { useNavigate } from '@tanstack/react-router'
import { Header } from '../components/Header'
import { Footer } from '../components/Footer'
import { CartDrawer } from '../components/CartDrawer'
import { Preloader } from '../components/Preloader'

interface StorefrontLayoutProps {
  children: React.ReactNode
  selectedCategory?: string | undefined
  setSelectedCategory?: (cat: string | undefined) => void
  onSearch?: (q: string) => void
}

export const StorefrontLayout: React.FC<StorefrontLayoutProps> = ({
  children,
  selectedCategory,
  setSelectedCategory,
  onSearch,
}) => {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen flex flex-col bg-[var(--bg-main)] text-[var(--text-primary)]">
      <Preloader />
      <Header
        onSearch={onSearch ?? (() => {})}
        onOpenTracking={() => navigate({ to: '/track' })}
        onOpenHallmarkGuide={() => navigate({ to: '/quality' })}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory ?? (() => {})}
      />
      <main className="flex-1">{children}</main>
      <Footer />
      <CartDrawer onCheckout={() => navigate({ to: '/checkout' })} />
    </div>
  )
}
